// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hi","advertCardHeader__actions":"c-a_hj","advertCardHeader__bottomLabel":"c-a_hk"};